import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { RECOMMENDATION_DISMISS_ALL_MT_REASONID_CONFIGS } from './reason-const';

export function reasonToMtTranslator(type, reasonId) {
  switch (type) {
    case (RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY): {
      if (!RECOMMENDATION_DISMISS_ALL_MT_REASONID_CONFIGS[type].excludedReason.includes(reasonId)) {
        return `${RECOMMENDATION_DISMISS_ALL_MT_REASONID_CONFIGS[type].prefix}${reasonId}`;
      }
      break;
    }
    default: {
      break;
    }
  }
  return reasonId;
}
